module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/cashflow-icon-3b841189e1720dad2c9e9dbf31c81ab7.svg";